module.exports = __webpack_public_path__ + "img/partners_tianjinguangbodianshitai.0ac8053f.png";